<template>
  <FullScreenDialog
    v-model="schedulePaymentsSettingsDialog"
    title="Modifica tipologia rata"
    :routeFather="pathToGoBack"
    :routeFatherName="pathName"
    :otherGoBackParams="{ params: { filters: this.filters } }"
  >
    <template v-slot:toolbar-extension>
      <v-tabs v-model="tab" align-with-title>
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          v-for="tab in schedulePaymentsSettingsTabs"
          :key="tab.key"
        >{{ tab.title }}</v-tab>
      </v-tabs>
    </template>

    <template v-slot:content>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="tabItem in schedulePaymentsSettingsTabs" :key="tabItem.key">
          <v-card flat>
            <v-card-text class="pa-0">
              <component :is="tabItem.component"></component>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </template>

    <template v-slot:footer-actions>
      <div>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="error"
          @click="closeDialog()"
        >Annulla</v-btn>
        <v-btn
          text
          color="default"
          :disabled="!formValid || isLicenseBlocked"
          @click="submitForm"
        >Salva</v-btn>
      </div>
    </template>

<!-- KEEP COMMENT - ONEWARE-562   
    <template v-slot:header-actions>
      <div>
        <StandardMenu
          close-on-content-click
        >
          <template v-slot:activator="{on, attrs}">
            <v-btn icon v-on="on" v-bind="attrs">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list>
              <v-list-item link>
                <v-list-item-icon class="mr-3">
                  <v-icon>mdi-printer</v-icon>
                </v-list-item-icon>
                <v-list-item-content>Stampa</v-list-item-content>
              </v-list-item>
              <v-list-item link>
                <v-list-item-icon class="mr-3">
                  <v-icon color="error">mdi-backspace-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="error--text">Resetta</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </StandardMenu>
      </div>
    </template> -->
  </FullScreenDialog>
</template>

<script>
import FullScreenDialog from "@/components/common/FullScreenDialog.vue";
import StandardMenu from '@/components/common/StandardMenu.vue';
import GeneralForm from "@/components/areas/payments/schedulePaymentsSettings/form/GeneralFormTab.vue"
import schedulePaymentsSettingsService from '@/services/schedulePaymentsSettings/schedulePaymentsSettings.service.js'
import schedulePaymentsSettingForm from '@/services/schedulePaymentsSettings/schedulePaymentsSettings.form.js'



export default {
  name: "SchedulePaymentsSettingsEditForm",
  components: {
    FullScreenDialog,
    StandardMenu,
    GeneralForm
  },
  data: function () {
    return {
      id: undefined,
      tab: null,
      formValid: false,
      loadingSchedulePaymentsSettings: false,
      schedulePaymentsSettingsDialog: this.openDialog,
      schedulePaymentsSettingsTabs: [
        {
          key: 0,
          title: "Generale",
          name: "general",
          component: "GeneralForm"
        }
      ],
      schedulePaymentsSetting: undefined,
      originalUrl: window.location.pathname,
      isLicenseBlocked: undefined
    };
  },
  mounted() {
    this.changeTabBasedOnProp(this.tabName)

    this.id = this.$route.params.id
    if(this.id) {
      this.fetchSchedulePaymentsSetting()
    }


    let self = this
    schedulePaymentsSettingForm.on('update', function(data) {
      self.schedulePaymentsSetting = data.schedulePaymentsSetting
    })

    self.valid = schedulePaymentsSettingForm.valid
    schedulePaymentsSettingForm.on('valid-change', function(valid) {
      self.formValid = valid
    })
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false,
    },
    pathToGoBack: {
      type: String,
      default: "/payments",
    },
    pathName: {
      type: String,
    },
    tabName: {
      type: String,
      default: 'general'
    },
    filters: {
      type: Array
    }
  },
  methods: {
    changeTabBasedOnProp(tabName) {
      for(let i = 0; i < this.schedulePaymentsSettingsTabs.length; i++) {
        if(this.schedulePaymentsSettingsTabs[i].name == tabName) {
          this.tab = i
          break
        }
      }
    },
    submitForm() {
      schedulePaymentsSettingsService.update(this.schedulePaymentsSetting).then((result) => {
        if (!!this.pathToGoBack) {
          this.close()
        }
      })
    },
    closeDialog() {
      if (this.pathToGoBack) {
        this.close()
      } else {
        this.schedulePaymentsSettingsDialog = false
        this.$emit('update:open-dialog', false)
      }
    },
    close() {
      if(!!this.pathName)
        this.$router.push({name: this.pathName, params: { filters: this.filters }})
      else
        this.$router.push({path:this.pathToGoBack})
    },
    fetchSchedulePaymentsSetting() {
      this.loadingSchedulePaymentsSetting = true
      schedulePaymentsSettingForm.resetSchedulePaymentsSetting()
      schedulePaymentsSettingsService.get(this.id).then((schedulePaymentsSetting) => {
        this.loadingSchedulePaymentsSetting = false
        schedulePaymentsSettingForm.updateObject(schedulePaymentsSetting)
      })
    }
  },
  watch: {
    openDialog(newVal) {
      this.schedulePaymentsSettingsDialog = newVal;
    },
    tab(newVal) {
      try {
        window.history.pushState("Tab", "Tab", this.originalUrl + '?tabName=' + this.schedulePaymentsSettingsTabs[newVal].name);
      } catch(err) {
        console.log('try setting the tab name but something goes wrong')
      }
    }
  },
  isLicenseBlocked: {
    bind: 'isLicenseBlocked'
  }
};
</script>